<!--
 * @Author: wufei
 * @Date: 2020-08-10 16:50:11
 * @LastEditTime: 2020-10-12 16:45:21
 * @Description:
 * @FilePath: \mobile-revive\src\views\index\detail.vue
-->
<template>
  <div class="revive-detail" @click="popdown">
    <div v-if="show" class="mask" />
    <div class="detail-title">
      <title-comp title="投资预测量价偏差" />
    </div>
    <header>
      <ul>
        <li :class="{active:show === 'year'}" @click.stop="showPopup('year')">{{ showYear }} <icon name="arrow-down" /></li>
        <li :class="{active:show === 'month'}" @click.stop="showPopup('month')">{{ showMonth }} <icon name="arrow-down" /></li>
        <li :class="{active:show === 'department'}" @click.stop="showPopup('department')">
          <div class="busList">
            {{ showBus }}
          </div>
          <icon name="arrow-down" />
        </li>
        <li :class="{active:show === 'city'}" @click.stop="showPopup('city')">
          <div class="busList">
            {{ showCity }}
          </div>
          <icon name="arrow-down" />
        </li>
      </ul>
      <div v-if="show" class="popup">
        <picker
          v-show="show == 'year'"
          title="请选择年份"
          :columns="years"
          :default-index="yearIndex"
          @change="yearChange"
        />

        <div v-show="show == 'month'" class="months">
          <div v-for="item in months" :key="item.text" class="item" :class="{active:item.state,disable:!item.enabled}" @click.stop="monthSelected(item)">{{ item.text }}月</div>
        </div>

        <picker
          v-show="show == 'department'"
          title="请选择事业部"
          value-key="orgShortName"
          :columns="BussinesDepList"
          :default-index="busIndex"
          @change="busChange"
        />

        <picker
          v-show="show == 'city'"
          title="请选择城市公司"
          value-key="orgShortName"
          :columns="cityCompanyList"
          :default-index="cityIndex"
          @change="cityChange"
        />
      </div>
    </header>

    <div class="scatter-container">
      <div ref="scatterChart" class="myCharts scatter-chart" />
    </div>

    <revive-table
      v-if="tableRender"
      :curr-year="currYear"
      :select-month="selectMonth"
      :curr-bus="currBus"
      :curr-city="currCity"
      :time="time"
    />

  </div>
</template>

<script>
import { setTitle } from '@/api/dd'
import TitleComp from '@/components/TitleComp'
import reviveTable from './table'
import { Icon, Picker, Toast, Button } from 'vant'
import { getBussinesDeptList, getCitycompanyList, getDataDict } from '@/api/sys'
import { scatterChart, lineChart, findOpeningTimeMonth } from '@/api/revive'

export default {
    name: 'ReviveDetail',
    components: {
        Icon,
        Picker,
        TitleComp,
        reviveTable
    },
    data() {
        return {
            userBelong: JSON.parse(sessionStorage.getItem('userBelone')),
            time: +new Date(),
            currentDate: new Date().getFullYear(),
            currYear: new Date().getFullYear(),
            selectMonth: [],
            show: '',
            years: [],
            months: [],
            selectedMonth: [],
            yearIndex: 0,
            currBus: '',
            currCity: '',
            busIndex: '',
            cityIndex: 0,
            BussinesDepList: [],
            cityCompanyList: [],
            keyword: '',
            // 散点图数据
            scatterData: {
                obtainsList: [],
                focusList: [],
                otherList: []
            },
            max: 30,
            tableRender: false
        }
    },
    computed: {
        showYear() {
            if (this.currYear) {
                return this.currYear
            }
            return '年份'
        },
        showMonth() {
            let text = ''
            if (this.selectedMonth.length) {
                this.selectedMonth.forEach(item => {
                    text += item.text + '月 '
                })
                text.trim()
                return text
            }
            return '月份'
        },
        showBus() {
            const bus = this.BussinesDepList.find(item => item.orgDeptId === this.currBus)
            if (bus) {
                return bus.orgShortName
            }
            return '事业部'
        },
        showCity() {
            const bus = this.cityCompanyList.find(item => item.orgDeptId === this.currCity)
            if (bus) {
                return bus.orgShortName
            }
            return '全部'
        }
    },
    watch: {
        selectedMonth(n) {
            this.months.forEach(item => {
                const select = n.find(month => month.text === item.text)
                item.state = false
                if (select) {
                    item.state = true
                }
            })
        },
        async yearIndex(n) {
            const item = this.years[n]
            this.currYear = item.text
            await this.findOpeningTimeMonth()
            this.initScatterChart()
            this.time = +new Date()
        },
        busIndex(n) {
            const item = this.BussinesDepList[n]
            this.currBus = item.orgDeptId
            if (this.currBus) {
                this.getCitycompanyList()
            } else {
                this.cityCompanyList = []
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)
            }
            this.initScatterChart()
            this.time = +new Date()
        },
        cityIndex(n) {
            const item = this.cityCompanyList[n]
            this.currCity = item.orgDeptId
            this.initScatterChart()
            this.time = +new Date()
        }
    },
    async created() {
        setTitle('复盘明细')
        this.initYear()
    },
    async mounted() {
        await this.findOpeningTimeMonth()
        await this.getBussinesDeptList()
        if (this.userBelong.type === 3) {
            await this.getCitycompanyList()
        }
        await this.lineChart()
        await this.initScatterChart()
    },
    methods: {
        async findOpeningTimeMonth() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            const parmas = {
                openingTimeYear: this.currYear,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await findOpeningTimeMonth(parmas).then(res => {
                this.months.forEach(item => {
                    const month = res.find(month => +month == item.text)
                    if (month) {
                        item.enabled = true
                    } else {
                        item.enabled = false
                        item.state = false
                    }
                })
                this.selectedMonth = this.months.filter(item => item.state)
            })
        },
        async initScatterChart() {
            await this.scatterChart()
            var data1 = [
                [-10.0, 8.04],
                [-33.0, 30.95, 2],
                [-53.0, 7.58, 1],
                [53, 33.81, 2]
            ]

            var data2 = [
                [11.0, 8.33, 1],
                [14.0, -39.96, 2],
                [-6.0, 7.24, 1]
            ]

            var data3 = [
                [54.0, 4.26, 1],
                [32.0, -10.84, 2],
                [7.0, -4.82, 1],
                [5.0, 5.68, 2]
            ]
            const scatterChart = this.$echarts.init(this.$refs.scatterChart)
            setTimeout(() => {
                let option = {
                    xAxis: {name: '流量', min: -this.max * 3 * 1.1, max: this.max * 3 * 1.1},
                    yAxis: {name: '均价', min: -this.max * 1.1, max: this.max * 1.1, axisTick: {length: 10}},
                    color: ['#C23431', '#61A0A8', '#BDA29A'],
                    legend: {
                        icon: 'circle',
                        data: ['我司获取', '重点跟进', '其他'],
                        bottom: 10
                        // textStyle: {
                        //     backgroundColor: 'white'
                        // }
                    },
                    tooltip: {
                        confine: true,
                        trigger: 'item',
                        position: 'bottom',
                        formatter: function(data) {
                            return data.data[2]
                        }
                    },
                    dataZoom: [
                        // {
                        //     type: 'slider',
                        //     show: true,
                        //     xAxisIndex: [0]
                        // },
                        // {
                        //     type: 'slider',
                        //     show: true,
                        //     yAxisIndex: [0]
                        // },
                        {
                            type: 'inside',
                            show: true,
                            xAxisIndex: [0]
                        },
                        {
                            type: 'inside',
                            show: true,
                            yAxisIndex: [0]
                        }
                    ],
                    series: [
                        {
                            name: '我司获取',
                            symbolSize: 10,
                            data: this.scatterData.obtainsList,
                            // data: data1,
                            type: 'scatter',
                            markArea: { // 标记区域
                                itemStyle: { // 全局的
                                    normal: {
                                        color: '#ff3333',
                                        borderType: 'dotted'

                                    }
                                },
                                data: [
                                    [
                                        {
                                            coord: ['-15', '-5'],
                                            itemStyle: {
                                                color: 'rgba(255,255,255,.3)',
                                                borderType: 'dashed',
                                                borderColor: 'black',
                                                borderWidth: '1'
                                            }
                                        }, {
                                            coord: ['15', '5']
                                        }],
                                    [{
                                        coord: ['-30', '-10'],
                                        itemStyle: {
                                            color: 'rgba(255,255,255,.3)',
                                            borderType: 'dashed',
                                            borderWidth: '1',
                                            borderColor: 'black'
                                        }
                                    }, {
                                        coord: ['30', '10']
                                    }]
                                ]
                            }
                        },
                        {
                            name: '重点跟进',
                            symbolSize: 10,
                            data: this.scatterData.focusList,
                            // data: data2,
                            type: 'scatter'
                        },
                        {
                            name: '其他',
                            symbolSize: 10,
                            data: this.scatterData.otherList,
                            // data: data3,
                            type: 'scatter'
                        }
                    ]

                }

                console.log(option)
                scatterChart.setOption(option)
            }, 300)
        },
        async lineChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            this.selectMonth = selectMonth
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                cityCompId: this.currCity
            }
            await lineChart(parmas).then(res => {
                const userBelong = JSON.parse(sessionStorage.getItem('userBelone'))
                if (userBelong.type === 1) {
                    this.currBus = res.length && res[0].orgId || ''
                    const index = this.BussinesDepList.findIndex(item => item.orgDeptId === this.currBus)
                    this.busIndex = index
                }
                this.tableRender = true
            })
        },
        async scatterChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            console.log('bus', this.currBus)
            this.selectMonth = selectMonth
            const parmas = {
                openingTimeYear: this.currYear,
                openingTimeMonths: selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await scatterChart(parmas).then(res => {
                this.scatterData.obtainsList = []
                this.scatterData.focusList = []
                this.scatterData.otherList = []
                this.max = 30
                res.obtainsList.forEach(item => {
                    this.max = Math.max(this.max, Math.abs(item.devMonthFlow), Math.abs(item.devAvgPrice))
                    const arr = [item.devMonthFlow, item.devAvgPrice, item.landName]
                    this.scatterData.obtainsList.push(arr)
                })

                res.focusList.forEach(item => {
                    this.max = Math.max(this.max, Math.abs(item.devMonthFlow), Math.abs(item.devAvgPrice))
                    const arr = [item.devMonthFlow, item.devAvgPrice, item.landName]
                    this.scatterData.focusList.push(arr)
                })

                res.otherList.forEach(item => {
                    this.max = Math.max(this.max, Math.abs(item.devMonthFlow), Math.abs(item.devAvgPrice))
                    const arr = [item.devMonthFlow, item.devAvgPrice, item.landName]
                    this.scatterData.otherList.push(arr)
                })
            })
        },
        busChange(picker, value, index) {
            this.busIndex = index
        },
        cityChange(picker, value, index) {
            this.cityIndex = index
        },
        yearChange(picker, value, index) {
            this.yearIndex = index
        },
        async getBussinesDeptList() {
            let type = 292700
            let ids = []
            await getDataDict({type}).then(res => {
                ids = JSON.parse(res[0].otherCode)
            })
            console.log(ids)
            // const ids = ['10010000', '10100000', '10040000', '10030000', '50007348', '10270000',
            //     '10120000', '10150000', '10070000', '10020000', '50007031', '10060000', '10170000', '10080000', '10130000', '10110000']
            await getBussinesDeptList().then(res => {
                this.BussinesDepList = res
                this.BussinesDepList = this.BussinesDepList.filter(item => {
                    if (ids.includes(item.orgDeptId)) {
                        return item
                    }
                })
                this.BussinesDepList.forEach(item => {
                    item.orgShortName = item.orgShortName
                        .replace('区域集团', '')
                        .replace('城市更新', '城更')
                        .replace('城市公司', '')
                        .replace('事业部', '')
                        .replace('区域集团', '')
                        .replace('旭辉银盛泰集团', '')
                        .replace('办事处', '')
                        .replace('公司', '')
                        .replace('区域', '')
                })
                const userBelong = JSON.parse(sessionStorage.getItem('userBelone'))
                if (userBelong.type != 1) {
                    this.BussinesDepList = this.BussinesDepList.filter(item => item.orgDeptId === userBelong.areaDeptId)
                    this.currBus = userBelong.areaDeptId
                }
            })
        },
        async getCitycompanyList() {
            await getCitycompanyList(this.currBus).then(res => {
                this.cityCompanyList = res
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)

                if (this.userBelong.type === 3) {
                    this.cityCompanyList = this.cityCompanyList.filter(item => item.orgDeptId === this.userBelong.cityCompId)
                    this.currCity = this.userBelong.cityCompId
                }
            })
        },
        popdown() {
            if (this.show) {
                this.initScatterChart()
                this.time = +new Date()
            }
            this.show = false
        },
        getActive(month) {
            const item = this.selectedMonth.find(item => item == month)
            if (item) {
                return true
            }
            return false
        },
        monthSelected(month) {
            if (!month.enabled) {
                Toast.fail('该月份不可选')
                return false
            }
            this.selectedMonth = [month]
            this.selectMonth = [month.text]
            this.popdown()
        },
        monthCheck(month) {
            let {text, state} = month
            this.selectedMonth = this.months.filter(item => item.state)
            let min = 0
            let max = 0
            this.selectedMonth.forEach(item => {
                if (min > item.text) {
                    min = item.text
                }
                if (max < item.text) {
                    max = item.text
                }
            })
            // console.log('max', max, 'min', min)
            if (!state) {
                if (text < min) return
                if (text < max) {
                    this.selectedMonth = this.selectedMonth.filter(item => {
                        return item.text < text
                    })
                }
            }

        },
        initYear() {
            // const minYear = this.currentDate - 100
            for (let i = 2019;i <= this.currentDate;i++) {
                this.years.push({text: i})
            }
            this.yearIndex = this.years.length - 1

            let month = new Date().getMonth()
            month = month === 0 ? 12 : month
            // 如果是12月份年份回到上一年
            this.yearIndex = month === 12 ? this.yearIndex - 1 : this.yearIndex
            // 默认选中上个月
            for (let i = 1;i <= 12;i++) {
                this.months.push({text: i, state: month === i})
                if (month === i) {
                    this.selectedMonth.push({text: i, state: month === i})
                }

            }
        },
        showPopup(type) {
            this.show = type
        }
    }
}
</script>

<style lang="scss" scoped>
    .revive-detail {
      box-sizing: border-box;
      overflow-y: auto;
      height:100%;
      font-size:.28rem /* 28/100 */;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      padding-bottom: 1.5rem;
      .mask {
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.42);
        position: absolute;
        z-index: 98;
      }
      .detail-title {
        box-sizing: border-box;
        padding:.3rem /* 30/100 */;
        height:.9rem /* 90/100 */;
        background:rgba(248,248,248,1);
        position: relative;
        z-index:99;
      }
      header {
        z-index:99;
        width:100%;
        height:.9rem /* 90/100 */;
        background: white;
        position: relative;
        ul {
          display:flex;
          padding:0 .3rem;
          li {
            display:flex;
            justify-content: center;
            flex:1;
            line-height:.9rem /* 90/100 */;
            .busList {
                max-width:1rem /* 100/100 */;
                white-space: nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
            }
            i {
                line-height:.9rem /* 90/100 */;
            }
          }
          li.active {
            color:#2761FF;
          }

        }
        .popup {
          position: absolute;
          z-index:99;
          width:100%;
          .months {
            display: flex;
            flex-wrap: wrap;
            background: white;
            padding:.25rem /* 10/100 */;
            .item {
              width:1.55rem /* 155/100 */;
              height:.46rem /* 46/100 */;
              background:rgba(247,247,247,1);
              border-radius:.04rem /* 4/100 */;
              margin:.1rem /* 20/100 */;
              font-size:.24rem /* 24/100 */;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(110,110,110,1);
              line-height:.46rem /* 46/100 */;
              text-align: center;
            }
            .active {
              background:#2761FF;
              color:white;
            }
            .disable {
              background:rgba(0,0,0,.6);
              color:white;
            }
          }
        }
      }

      .scatter-container {
        height:7.5rem /* 750/100 */;
        background:rgba(243,243,243,1);
        .scatter-chart {
          height:100%;
        }
      }

    }
</style>

<style lang="scss">
    .revive-detail {
        .van-picker-column {
            // font-size:.24rem /* 24/100 */;
        }

        .my-button.round {
            .van-icon {
                    font: .3rem /* 20/100 */ "vant-icon";
            }
        }

        .van-search__content {
          border-radius: .3rem /* 30/100 */;
        }
    }
</style>
